import React from 'react';
import LargeButton from '../../shared/components/LargeButton';
import cx from 'classnames';

/**
 * @typedef {object} OrgUnitInfoCardProps
 * @property {(id: number) => void} onClick
 * @property {Object} orgUnit
 */

/**
 * @param {OrgUnitInfoCardProps} props
 */
const OrgUnitInfoCard = props => {
  const { orgUnit, onClick } = props;

  const stateAndZipCode = [orgUnit.State, orgUnit.ZipCode].filter(Boolean).join(' ');

  const address = [orgUnit.Address1, orgUnit.Address2, orgUnit.City, stateAndZipCode]
    .filter(Boolean)
    .join(', ');

  return (
    <div key={orgUnit.Id} className='item-search__results-row'>
      <LargeButton
        onClick={() => onClick(orgUnit.Id)}
        className={cx({ inactive: !orgUnit.IsActive })}>
        <div className='button__sections'>
          <div className='button__section-column'>
            <div className='button__org-unit'>{orgUnit.Name}</div>
            <div>{orgUnit.MddapOrganization.Name}</div>
          </div>
          <div className='button__section-column'>
            <div>{address}</div>
            <div>FEI # {orgUnit.Fei}</div>
          </div>
          <div className='button__section-column'>
            <div>{orgUnit.IsActive ? 'Enrolled' : 'De-Enrolled'}</div>
          </div>
        </div>
      </LargeButton>
    </div>
  );
};

export default OrgUnitInfoCard;
